import { render, staticRenderFns } from "./CadastrarUser.vue?vue&type=template&id=2c79fb64&"
import script from "./CadastrarUser.vue?vue&type=script&lang=js&"
export * from "./CadastrarUser.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports